import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import Select from "react-select";
import "../../assets/css/stepper.css";

import {
  addGroup,
  updateGroup,
  getGroupDetails,
} from "../../../src/services/Users-services";
import {
  callToast,
  showErrorMessages,
} from "../../services/utilityFunctions.js";

import { useGlobalState } from "../../services/hostelConst";
import { getLocalStorageData } from "../../services/axiosComponent";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../services/redux/reducers/modalSlice";
const AddGroupForm = (props) => {
  var { refresh } = props;
  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const navigate = props.navigate;

  const prepareFormData = (data) => {
    return {
      name: data == null ? "" : data.NAME,
      description: data == null ? "" : data.DESCRIPTION,
    };
  };
  const [formData, setFormData] = useState(prepareFormData());
  const [data, setData] = useState(null);
  const [dataLoading, setDataLoading] = useState(modal.isEditing);
  const getGroupDetailsData = async () => {
    setDataLoading(true);
    var res = await getGroupDetails(modal.data._ID);
    if (res.status == "success") {
      setFormData(prepareFormData(res.data));
      setData(res.data);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setDataLoading(false);
  };
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (modal.isEditing == true) {
      getGroupDetailsData();
    }
    return () => {};
  }, []);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!formData.description.trim()) {
      // console.log("Description is required");
      newErrors.description = "Description is required";
    }

    // Step 2 validation

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      var profileData = getLocalStorageData("profileDetails");
      var dataToSubmit = {
        groupDescription: formData.description,
        organizationId: profileData["_ORGANIZATION_"]._ID,
        ownerId:
          modal.isEditing == false ? profileData._ID : data["_GROUP OWNER"],
        regionId:
          modal.isEditing == false ? profileData["_REGION"] : data["_REGION"],
        siteId: modal.isEditing == false ? profileData["_SITE"] : data["_SITE"],
        id: modal.isEditing == false ? "" : data["_ID"],

        groupName: formData.name,
      };

      var res =
        modal.isEditing == false
          ? await addGroup(dataToSubmit)
          : await updateGroup(dataToSubmit);
      if (res.status == "success") {
        callToast(
          "success",
          "Success",
          data == null
            ? "Group Added Successfully"
            : "Group Updated Successfully"
        );

        await refresh({ columnRefresh: false, isLoading: false });
        dispatch(closeModal());
      } else {
        showErrorMessages({ data: res, navigate });
      }
      setLoading(false);
    }
  };

  return (
    <>
      {dataLoading ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <section className="">
          <div className="d-flex  justify-content-center ">
            <div className="w-100 m-3">
              {/* <div
              className="position-absolute top-10 start-20 bg-primary"
              style={{
                left: "5%",
                top: "-10%",
                width: "12%",
                height: "110%",
                backgroundColor: "blue",
              }}
            ></div> */}

              <div className="d-flex h-100">
                <div className="w-100">
                  {/* <div className="d-flex justify-content-start">
                  <strong className="text-primary" style={{ fontSize: "2rem" }}>
                    Sites
                  </strong>
                </div> */}

                  <>
                    <div className="stepper mb-3 ">
                      <div className="d-flex justify-content-between">
                        <div className={`step active`}>Group Info</div>
                      </div>
                    </div>

                    {
                      // Step 1: Site Info
                      <>
                        <div className="mb-3 m-4">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Group Name"
                            value={formData.name}
                            onChange={(e) =>
                              handleChange("name", e.target.value)
                            }
                          />
                          {errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </div>

                        <div className="mb-3 m-4">
                          <label className="form-label">Description</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Description"
                            value={formData.description}
                            onChange={(e) =>
                              handleChange("description", e.target.value)
                            }
                          />
                          {errors.description && (
                            <small className="text-danger">
                              {errors.description}
                            </small>
                          )}
                        </div>

                        <div className="d-flex justify-content-end m-3 mb-0">
                          <Button
                            type="submit"
                            disabled={loading}
                            onClick={handleSubmit}
                          >
                            {loading ? (
                              <div
                                class="spinner-border text-light"
                                role="status"
                              >
                         
                              </div>
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </div>
                      </>
                    }
                  </>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddGroupForm;
